<template>
    <div class="col-sm-6 mb-4">
        <div class="py-3 bg-lighter">

            <div class="col-sm-12 dark font-weight-600 justify-content-between d-flex">
                <span>Custom <toggle-button v-model="isCustomTransport" :labels="{checked: 'Yes', unchecked: 'No'}" @change="isCustomChange" /></span>
                <span class="dark py-1 px-2">{{(transportType == 1) ? 'Pickup' : 'Drop Off'}}</span>
            </div>

            <div class="col-sm-12 my-2" v-if="isCustomTransport">
                <span v-if="getCompanySettings.settingsPresets" class="dark font-weight-600">
                    {{getCompanySettings.settingsPresets.customRouteNote}}
                </span>
            </div>

            <div v-if="!isCustomTransport">
                <div class="col-sm-12 mt-3">
                    <div class="d-flex flex-row justify-content-between">
                        <label>List</label>
                    </div>
                    <v-select :options="listOfRoutes" v-model="selectedRoute" label="name" @input="routeChanged(selectedRoute)"></v-select>
                </div>

                <div class="col-sm-12 mt-3" v-if="selectedRoute && listOfIteneraries">
                    <label>{{(transportType == 1) ? 'From' : 'To'}}</label>
                    <v-select v-if="listOfIteneraries" :options="listOfIteneraries" v-model="selectedItenerary" label="helperName" @input="iteneraryChanged(selectedItenerary)"></v-select>
                    <div class="mt-3" v-if="value.stop && value.stop.note">
                        <label>Note</label>
                        <div>{{value.stop.note}}</div>
                    </div>
                </div>

                <div class="col-sm-12 mt-3" v-if="selectedRouteExitStop">
                    <label>{{(transportType == 1) ? 'To' : 'From'}}</label>
                    <input type="text" class="d-block w-100" disabled :value="selectedRouteExitStop">
                </div>

                <div class="d-flex">
                    <div class="col-sm-6 mt-3" v-if="value.stop">
                        <label>Time</label>
                        <v-select class="w-100" :options="listOfSchedules" v-model="selectedSchedule" label="timeShort"></v-select>
                    </div>

                    <div class="col-sm-6 mt-3">
                        <label>Date</label>
                        <input type="text" class="d-block w-100" disabled :value="transportDate">
                    </div>
                </div>

            </div>

            <div v-if="isCustomTransport" class="col-sm-12">
                <div class="row">
                    <div class="col-sm-12 mt-3">
                        <div class="d-flex flex-row justify-content-between">
                            <label>From</label>
                        </div>
                        <input type="text" class="w-100" v-model="customFrom">
                    </div>

                    <div class="col-sm-12 mt-3">
                        <div class="d-flex flex-row justify-content-between">
                            <label>To</label>
                        </div>
                        <input type="text" class="w-100" v-model="customTo">
                    </div>

                    <div class="col-sm-6 mt-3">
                        <div class="d-flex flex-row justify-content-between">
                            <label>Date</label>
                        </div>
                        <datepicker input-class="bg-lightest w-100" v-model="customDate" format="dd/MM/yyyy" @input="customDateChanged"></datepicker>
                    </div>

                    <div class="col-sm-6 mt-3">
                        <div class="d-flex flex-row justify-content-between">
                            <label>Time</label>
                        </div>
                        <timepicker :defaultTime="customHour()" @change="setCustomTime"></timepicker>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import Timepicker from '@/tools/Timepicker'
import Datepicker from 'vuejs-datepicker';
import {mapGetters} from 'vuex'
import extendedVSelect from '@/extends/vue-select'
export default {
    props:{
        possibleRoutes: {
            default: function() {
                return []
            },
            type: Array
        },
        value: {
            type: Object
        },
        transportType: {
            default: 1,
            type: Number
        },
        eventDate: {

        }
    },
    data: function() {
        return {
            selectedRoute: null,
            selectedItenerary: null,
            selectedSchedule: null,
            vSelectCounters: {
                routeChanged: 0,
                iteneraryChanged: 0,
                customDateChanged: 0
            },
            customSchedule: {
                date: null,
                time: null,
                customTransportDefaultHour: null,
            },
            isCustomTransport: false,
            customFrom: null,
            customTo: null,
            customTime: null,
            customDate: null,
            customTransportDefaultHour:[
                "10","00"
            ]
        }
    },
    created: function() {
        // set the data from transfer if any
        this.setStoredData()
        // this.selectedItenerary = this.value.stop
        // this.selectedSchedule = this.value.schedule
    },
    computed: {
        ...mapGetters([
            'getCompanySettings'
        ]),
        listOfRoutes: function () {
            return this.possibleRoutes.filter(route => {
                return route.type == this.transportType
            })
        },
        selectedRouteExitStop: function() {
            return this.selectedRoute? this.selectedRoute.iteneraries[this.selectedRoute.iteneraries.length - 1].stop.name : null
        },
        listOfIteneraries: function () {
            if(!this.selectedRoute){
                return null
            }

            this.selectedRoute.iteneraries.map(itenerary => {
                itenerary.helperName = itenerary.stop.name
            })

            return this.selectedRoute.iteneraries
        },
        listOfSchedules: function () {
            if(!this.selectedItenerary){
                return null
            }

            return this.selectedItenerary.schedules? this.selectedItenerary.schedules : null
        },
        transportDate: function() {
            return moment(this.eventDate).format("DD.MM.YYYY")
        },
        // componentOutput: function () {
        //     let builtTransport = this.value
        //     builtTransport.date = this.eventDate
        //     builtTransport.transportDirection = this.transportType
        //     builtTransport.route = this.selectedRoute
        //     builtTransport.schedule = this.selectedSchedule
        //
        //     if(this.value.isCustom){
        //         builtTransport.stop.name = this.customFrom
        //         builtTransport.exitStop.name = this.customTo
        //     } else {
        //         builtTransport.stop = this.selectedItenerary.stop
        //         builtTransport.exitStop = this.selectedRoute.iteneraries[this.selectedRoute.iteneraries.length - 1].stop
        //     }
        //
        //     // this.$emit('input', builtTransport)
        //     return builtTransport
        // }
    },
    methods: {
        setStoredData: function () {
            let inputObject = JSON.parse(JSON.stringify(this.value))
            this.isCustomTransport = inputObject.isCustom

            if(this.isCustomTransport){
                console.log('here');
                this.customFrom = inputObject.stop.name
                this.customTo = inputObject.exitStop.name
            } else {
                // set selected route
                this.$set(this, 'selectedRoute', this.possibleRoutes.filter(route => {
                    return route.id == inputObject.route.id
                })[0])

                //set the selected stop
                this.$set(this, 'selectedItenerary', this.selectedRoute.iteneraries.filter(itenerary => {
                    return itenerary.stop.id == inputObject.stop.id
                })[0])

                //set the selected schedule
                this.$set(this, 'selectedSchedule', inputObject.schedule)
            }

        },
        isCustomChange: function (e) {
            if(e.value){
                this.$set(this, 'selectedSchedule', this.customSchedule)
                this.customHour()
            } else {
                this.$set(this, 'selectedSchedule', null)
            }
        },
        routeChanged: function(route) {
            // to prevent the first trigger on load
            if(this.vSelectCounters.routeChanged > 0){
                this.$set(this, 'selectedItenerary', null)
            }
            this.vSelectCounters.routeChanged++
        },
        iteneraryChanged: function(route) {
            // to prevent the first trigger on load
            if(this.vSelectCounters.iteneraryChanged > 0){
                this.$set(this, 'selectedSchedule', null)
            }
            this.vSelectCounters.iteneraryChanged++
        },
        customDateChanged: function(e) {
            this.customDate = moment(e).format('YYYY-MM-DD')
        },
        setCustomTime: function(e) {
            this.customTime = $event+':00'
        },
        customHour: function() {
            if(this.value.schedule.timeShort){
                return this.value.schedule.timeShort.split(":")
            } else {
                return this.customTransportDefaultHour
            }
        },
        componentOutput: function () {
            let builtTransport = this.value
            builtTransport.date = this.eventDate
            builtTransport.transportDirection = this.transportType
            builtTransport.route = this.selectedRoute
            builtTransport.schedule = this.selectedSchedule
            builtTransport.isCustom = this.isCustomTransport

            console.log('componentOutput outputing')
            if(this.isCustomTransport){
                builtTransport.stop.name = this.customFrom
                builtTransport.exitStop.name = this.customTo
                builtTransport.schedule.time = this.customTime
                builtTransport.schedule.date = this.customDate
            } else {
                builtTransport.stop = this.selectedItenerary.stop
                builtTransport.exitStop = this.selectedRoute.iteneraries[this.selectedRoute.iteneraries.length - 1].stop
            }
            // this.value = builtTransport;
            // this.$emit('input', this.value)
            // return builtTransport
            // this.$emit('input', builtTransport)
        },
    },
    watch: {
        // whenever question changes, this function will run
        selectedRoute: {
            handler: function (newVal, oldVal) {
                this.componentOutput()
            },
            deep: true
        },
        selectedItenerary: {
            handler: function (newVal, oldVal) {
                this.componentOutput()
            },
            deep: true
        },
        selectedSchedule: {
            handler: function (newVal, oldVal) {
                this.componentOutput()
            },
            deep: true
        },
        customFrom: {
            handler: function (newVal, oldVal) {
                this.componentOutput()
            },
            deep: true
        },
        customTo: {
            handler: function (newVal, oldVal) {
                this.componentOutput()
            },
            deep: true
        }
    },
    components: {
        vSelect: extendedVSelect,
        Timepicker,
        Datepicker
    }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// TransportEditor.vue?d3172112